export default __webpack_public_path__ + "043771c999cd4d47d9f33c9c7e42c392.ttf";